import React, { useContext } from 'react';
import type { ThemeType } from '../theme/glueTheme';
import { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';

interface Props {
    to: string;
    className?: string;
}

export const GraphsMenuItem: React.FC<Props> = ({ to, ...props }) => {
    const { primaryContrastColor } = useContext<ThemeType>(ThemeContext);

    return (
        <Link to={to} style={{ display: 'flex', alignItems: 'center' }} {...props}>
            <svg height={24} viewBox="258 172 508 172" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M766 195.609L742.908 172.541V185.847H666.015V328.001H742.908V340.459L766 317.391L742.908 294.322V308.262H689.375V263.633H736.678V276.395L759.771 253.326L736.678 230.258V244.089H689.375V205.488H742.908V218.678L766 195.609Z"
                    fill={primaryContrastColor}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M663.218 198.254L640.125 175.185V186.99C621.171 188.798 606.347 204.748 606.347 224.157H606.351V275.301C606.351 282.69 605.183 289.01 602.847 294.261C600.576 299.447 597.007 303.401 592.14 306.123C587.339 308.781 581.109 310.11 573.453 310.11C562.357 310.11 554.019 307.29 548.438 301.651C542.858 296.011 540.068 287.26 540.068 275.398V185.847H516.708V277.44C516.708 293.321 521.445 306.058 530.919 315.652C540.457 325.181 554.343 329.945 572.577 329.945C585.36 329.945 595.969 327.676 604.404 323.139C612.84 318.537 619.134 312.314 623.287 304.47C627.504 296.627 629.613 287.746 629.613 277.829V224.157C629.613 217.614 634.075 212.113 640.125 210.524V221.323L663.218 198.254Z"
                    fill={primaryContrastColor}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M364.728 175.968L376.578 206.369L346.146 218.207L351.407 206.248L349.979 205.877C344.009 204.321 337.812 203.543 331.388 203.543C321.201 203.543 312.409 205.747 305.011 210.155C297.679 214.563 292.034 220.786 288.076 228.824C284.117 236.797 282.138 246.228 282.138 257.118C282.138 267.684 283.728 276.954 286.908 284.927C290.087 292.9 295.051 299.123 301.799 303.595C308.613 308.003 317.405 310.207 328.176 310.207C333.562 310.207 338.137 309.915 341.9 309.332C345.664 308.749 349.135 308.1 352.315 307.387V270.731H322.239V250.798H375.382V322.167C367.92 324.63 360.198 326.542 352.217 327.903C344.236 329.265 335.282 329.945 325.354 329.945C310.884 329.945 298.62 327.093 288.562 321.389C278.569 315.62 270.978 307.29 265.787 296.4C260.596 285.445 258 272.254 258 256.827C258 241.983 260.888 229.115 266.663 218.225C272.438 207.271 280.841 198.811 291.872 192.848C302.902 186.82 316.269 183.805 331.972 183.805C339.694 183.805 347.156 184.583 354.359 186.139C356.634 186.802 358.297 187.324 359.543 187.753L364.728 175.968Z"
                    fill={primaryContrastColor}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M490.623 294.042L513.716 317.111L490.623 340.179V328.001H409.448V185.847H432.808V308.165H490.623V294.042Z"
                    fill={primaryContrastColor}
                />
            </svg>
        </Link>
    );
};
